import React, { Component } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './fanzaad.module.css'

export default class Fanzaad extends Component {

  render() {

    let ad
    if (this.props.type === 'monthly') {
      ad = <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fmonthly%2F&af_id=tana0423-003&ch=toolbar&ch_id=link" target="_blank" rel="sponsored noopener noreferrer">
      <StaticImage
        formats={["AUTO", "WEBP", "AVIF"]}
        src="../../../images/captures/fanzamonthlyad.png"
        alt="FANZA月額動画"
      />
    </a>
    } else if (this.props.type === 'ad') {
      ad = <><a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Ftv.dmm.co.jp%2Flist%2F%3Fgenres%3DRGdSSlRnbEVCUTRHd09DZGw1UGNrb3Nf%26viewing_plans%3DFANZA_TV&af_id=tana0423-003&ch=link_tool&ch_id=link" target="_blank" rel="sponsored noopener noreferrer">
      <StaticImage
        formats={["AUTO", "WEBP", "AVIF"]}
        src="../../../images/captures/fanzabookad.png"
        alt="FANZA TV"
      />
    </a>
    <div style={{ paddingTop: `2px`}}></div>
    <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Ftv.dmm.co.jp%2Flist%2F%3Fgenres%3DRGdSSlRnbEVCUTRHd09DZGw1UGNrb3Nf%26viewing_plans%3DFANZA_TV&af_id=tana0423-003&ch=link_tool&ch_id=text" rel="sponsored noopener noreferrer">FANZA TVで14日間の無料トライアル</a>
    </>
    } 

    return (
      <div className={styles.fanzaad}>
        {ad}
      </div>
    )
  }
}